import Result from "@/core/common/Result";
import {
  ICadastrarVoucherUseCaseParams,
  ICadastrarVoucherUsecase
} from "../ports/CadastrarVoucherUseCase";
import { inject, injectable } from "inversify";
import {
  type ICadastrarVoucherGateway,
  cadastrarVoucherGatewayDI
} from "../ports/CadastrarVoucherGateway";
import "reflect-metadata";

@injectable()
export default class CadastrarVoucherUseCaseAdapter
  implements ICadastrarVoucherUsecase
{
  @inject(cadastrarVoucherGatewayDI)
  gateway!: ICadastrarVoucherGateway;

  async cadastrar(
    params: ICadastrarVoucherUseCaseParams
  ): Promise<Result<void>> {
    const response = await this.gateway.cadastrar({
      email: params.email,
      telefone: params.telefone,
      voucherId: params.idVoucher
    });

    if (response.isFailure) return Result.fail(response.error);

    return Result.ok();
  }
}
